import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#004BF9',
        secondary: '#ACDD54',
      },
      dark: {
        primary: '#004BF9',
        secondary: '#ACDD54',
      }
    }
  },
});
